module.exports = __webpack_public_path__ + "static/media/15_Fire-and-Golden.f2a5748d.png";